export default function SearchFilter(element, options = {}) {
    if (!element) {
        return;
    }

    const searchFilterForm = element.closest('[data-search-filter-form]');

    if (searchFilterForm) {
        element.addEventListener('click', () => searchFilterForm.submit());
    }
};
